import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Icon } from '@iconify/react';
import { getCourseDetailsByIdForNotification } from '../../../services/userService';
import { encodeData } from '../../../utils/encodeAndEncode';
import moment from 'moment-timezone';

function NotificationDetails() {
  const location = useLocation();
  const navigate = useNavigate();
  const { notification } = location.state || {};
  const [courseDetails, setCourseDetails] = useState(null);

  useEffect(() => {
    const fetchCourseDetails = async () => {
      if (notification?.course_id) {
        try {
          const response = await getCourseDetailsByIdForNotification({
            course_id: notification.course_id
          });
          // console.log('Course Details:', response.data);
          setCourseDetails(response.data);
        } catch (error) {
          console.error('Error fetching course details:', error);
        }
      }
    };

    fetchCourseDetails();
  }, [notification]);

  if (!notification) {
    return (
      <div className="notification-details-container">
        <div className="text-center p-5">
          Notification not found
        </div>
      </div>
    );
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString();
  };

  const handleStartLearning = () => {
    if (!courseDetails) return;

    const encodedCourseId = encodeData({ id: notification.course_id });
    
    // If course is already purchased/enrolled, go directly to watch page
    if (courseDetails.is_course_purchase) {
      navigate(`/user/courses/WatchCourse/${encodeURIComponent(encodedCourseId)}`);
    } else {
      // For non-enrolled courses, redirect to course details page
      navigate(`/user/courses/courseDetails/${encodeURIComponent(encodedCourseId)}`);
    }
  };

  

  return (
    <div className="flex">
      <div className="w-full">
        <div>
          <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-4">
            <div>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">Title</label>
                <h3 className="text-xl font-semibold">{notification.title}</h3>
              </div>

              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">Message</label>
                <p className="text-gray-700">{notification.body}</p>
              </div>

              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">Date</label>
                <p className="text-gray-700">{moment.utc(notification.createdAt).local().format('MMM DD, YYYY, hh:mm A')}</p>

              </div>

              {notification.file_url && (
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1">Attachment</label>
                  <a 
                    href={notification.file_url} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-primary hover:text-primary/80 inline-flex items-center gap-2"
                  >
                    <Icon icon="mdi:file-document-outline" width="20" height="20" />
                    View Attachment
                  </a>
                </div>
              )}
            </div>

            {courseDetails && (
              <div className="bg-white rounded-lg shadow-sm border border-gray-100 mt-4">
                <div className="flex flex-col md:flex-row gap-0">
                  <div className="w-full md:w-2/5">
                    <img
                      src={courseDetails.imageName}
                      alt={courseDetails.course_name}
                      className="w-full h-full object-cover rounded-t-lg md:rounded-l-lg md:rounded-t-none"
                      onError={(e) => {
                        e.target.src = 'https://via.placeholder.com/400x300?text=Course+Image';
                      }}
                    />
                  </div>
                  <div className="w-full md:w-3/5 p-4">
                    <div>
                      <h2 className="text-2xl font-bold mb-2">{courseDetails.course_name}</h2>
                      <p className="text-gray-700 mb-4">{courseDetails.description}</p>
                      
                      <div className="flex items-center gap-2 mb-4">
                        <Icon icon="mdi:account" width="24" height="24" />
                        <span>{courseDetails.trainer_name}</span>
                      </div>
                      
                      <div className='w-full md:w-1/2'>
                      <button 
                        className="bg-primary hover:bg-primary/90 text-white font-medium py-2 px-4 rounded-lg flex items-center gap-2"
                        onClick={handleStartLearning}
                      >
                        <Icon icon="mdi:play-circle" width="20" height="20" />
                        Start Learning
                      </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotificationDetails;